import { postData } from '../plugins/ApiCalls'

// Asks the server (single source of truth for the disposable list) which email domains are
// temporary. Only domains are sent. Answers are remembered per domain for the page's lifetime.
const EMAIL_SEPARATORS = /[,;\s]+/
// Kept generic on purpose. A list gets wording that tells the user to fix the offending address
const INVALID_EMAIL_MESSAGE = 'Please enter a valid email address.'
const INVALID_EMAIL_LIST_MESSAGE = 'Please remove the invalid email address and add a valid one.'
const answers = new Map() // domain -> boolean

function extractEmails(value) {
  const list = Array.isArray(value) ? value : String(value || '').split(EMAIL_SEPARATORS)
  return list.map((email) => String(email).trim().toLowerCase()).filter((email) => email.split('@')[1]?.includes('.'))
}

const domainOf = (email) => email.split('@')[1]

async function lookUp(domains) {
  const response = await postData('email/disposable-check', { domains })
  const disposable = response?.data?.disposable || []
  domains.forEach((domain) => answers.set(domain, disposable.includes(domain)))
}

/**
 * Returns the addresses (from one address, a comma-separated string or a list) that use a
 * disposable domain. Never blocks the user if the check itself fails; the server checks again on save.
 */
export async function findDisposableEmails(value) {
  const emails = extractEmails(value)
  const unknown = [...new Set(emails.map(domainOf))].filter((domain) => !answers.has(domain))

  if (unknown.length) {
    try {
      await lookUp(unknown)
    } catch (e) {
      console.warn('Could not check for disposable email domains.', e)
      return []
    }
  }

  return emails.filter((email) => answers.get(domainOf(email)))
}

// Vuetify async rule: resolves to `true` or an inline error message.
export async function disposableEmailRule(value) {
  if (!(await findDisposableEmails(value)).length) return true
  const isList = Array.isArray(value) || /[,;]/.test(value)
  return isList ? INVALID_EMAIL_LIST_MESSAGE : INVALID_EMAIL_MESSAGE
}
